import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./StatementTable.module.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  getHistorystatement,
  getRaport,
  getRaportsHistory,
  getSendedForMeRaports,
} from "service/StatementsService";
import {
  setSignedStatements,
  setStatements,
} from "store/slices/StatementsSlice";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import userInfo from "utils/userInfo";
import { Spinner } from 'components/UnvUI'
function StatementTable({ render, filterChoose, setRender }) {
  const { t } = useTranslation("common");
  const user = userInfo();
  let [filteredData, setData] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("");
  const [selectedFilterStatus, setSelectedFilterStatus] = useState(4);
  const [loading, setLoading] = useState(true);

  const unique = (value, index, self) => {
    return self.indexOf(value) === index;
  };
  const dispatch = useDispatch();
 
 
  const navigate = useNavigate();

  const getData = async () => {
    try {
      if (filterChoose === 6) {

        let response = await getSendedForMeRaports(filteredData);

        dispatch(
          setSignedStatements({
            signed_statements: response.data,
          })
        );

        setData(response.data);


        setLoading(false);
      } else if (filterChoose === 5) {

        let response = await getRaportsHistory(filteredData);
        dispatch(
          setSignedStatements({
            signed_statements: response.data,
          })
        );

        setData(response.data);


        setLoading(false);
      } else if (filterChoose === 4)  {
        let response = await getRaport(filteredData);

        dispatch(
          setStatements({
            statements: response.data.Raports,
          })
        );
        setData(response.data.Raports);
        setLoading(false);
      }
    } catch (error) {

    }
  };

  const allStatements = useSelector((state) => state.statement);

  useEffect(() => {
    getData();
    setLoading(true);
    setRender(false)
  }, [render, filterChoose]);


  if (selectedFilter !== "" && selectedFilter !== "Все") {
    filteredData = filteredData?.filter(
      (item) => item.type_doc === selectedFilter
    );
  }
  const handleClick = (id) => {

    if (typeof id !== 'undefined') {
      navigate(`/statement/`, { state: { usedId: id } });
    }
  };


  return (
    <div className={styles.wrapper_table_body}>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100px",
          }}
        >
          <Spinner size={28} />{" "}
          
        </div>
      ) : (
        <table className={styles.table__wrapper}>
          <thead className={styles.table__head}>
            <tr className={styles.table__row}>
              <th className={styles.table__item}>
                <span className={styles.table__title}>{t('statements.list.number')}</span>
              </th>
              <th className={styles.table__item}>
                <span className={styles.table__title}>{t('statements.list.applicant')}</span>
              </th>
              <th className={styles.table__item}>
                <span className={styles.table__title}>
                  {" "}
                  <select
                    className={styles.select__dropdown}
                    value={selectedFilter}
                    onChange={(e) => setSelectedFilter(e.target.value)}
                  >
                   <option value="Все">{t('statements.list.all')}</option>
                  <option value="Рапорт">{t('statements.list.report')}</option>
                  <option value="Заявление">{t('statements.list.statement')}</option>
                  <option value="Бизнес план">{t('statements.list.business_plan')}</option>
                  <option value="Благодарственное письмо">{t('statements.list.thank_letter')}</option>
                  <option value="Деловое письмо">{t('statements.list.business_letter')}</option>
                  <option value="Договор">{t('statements.list.contract')}</option>
                  <option value="Жалоба">{t('statements.list.complaint')}</option>
                  <option value="Запрос на информацию">{t('statements.list.info_request')}</option>
                  <option value="Заявление">{t('statements.list.statement')}</option>
                  <option value="Обращение">{t('statements.list.appeal')}</option>
                  <option value="Паспорт проекта">{t('statements.list.project_passport')}</option>
                  <option value="Письмо">{t('statements.list.letter')}</option>
                  <option value="Приказ">{t('statements.list.order')}</option>
                  <option value="Приглашение">{t('statements.list.invitation')}</option>
                  <option value="Рапорт">{t('statements.list.report')}</option>
                  <option value="Уведомление">{t('statements.list.notification')}</option>


                  </select>
                </span>
              </th>
              <th className={styles.table__item}>
                <span className={styles.table__title}>{t('statements.list.subject')}</span>
              </th>
              <th className={styles.table__item}>
                {filterChoose === 5 ? (
                  <span className={styles.table__title}>{t('statements.list.status')}</span>
                ) : filterChoose === 6 ? (
                  <span className={styles.table__title}>{t('statements.list.status')}</span>
                ) : (
                  <span className={styles.table__title}>
                    {" "}
                    <select
                      className={styles.select__dropdown}
                      value={selectedFilterStatus}
                      onChange={(e) =>
                        setSelectedFilterStatus(parseInt(e.target.value))
                      }
                    >
                      <option value={4}>{t('statements.list.all')}</option>
                      <option value={0}>{t('statements.menu.pending')}</option>
                      <option value={1}>{t('statements.menu.in_progress')}</option>
                      <option value={2}>{t('statements.menu.completed')}</option>


                    </select>
                  </span>
                )}
              </th>
              <th className={styles.table__item}>
                <span className={styles.table__title}>{t('statements.list.submission_date')}</span>
              </th>
            </tr>
          </thead>

          <tbody className={styles.table__body}>
            
            {filteredData?.filter(unique)
              .reverse()
              .map((item, index) => {
                return (
                  <>
                    {!item.is_watched ? (

                      <tr
                        key={index}
                        className={styles.table__row1}
                        onClick={() => handleClick(item.id)}
                      >
                        <td className={styles.table__item1}>
                          <span className={styles.table__title1}>{item.number}</span>
                        </td>
                        <td className={styles.table__item1}>
                          <span className={styles.table__title1}>
                            {item.employee.first_name} {item.employee.surname}
                          </span>
                        </td>
                        <td className={styles.table__item1}>
                          <span className={styles.table__title1}>
                            {item.type_doc}
                          </span>
                        </td>
                        <td className={styles.table__item1}>
                          <span className={styles.table__title1}>{item.type}</span>
                        </td>
                        <td className={styles.table__item1}>
                          <span className={styles.table__title1}>{item.status}</span>
                        </td>
                        <td className={styles.table__item}>
                          <span className={styles.table__title1}>
                            {item.date_zayavki}
                          </span>
                        </td>
                      </tr>


                    ) : (<tr
                      key={index}
                      className={styles.table__row}
                      onClick={() => handleClick(item.id)}
                    >
                      <td className={styles.table__item}>
                        <span className={styles.table__title}>{item.number}</span>
                      </td>
                      <td className={styles.table__item}>
                        <span className={styles.table__title}>
                          {item.employee.first_name} {item.employee.surname}
                        </span>
                      </td>
                      <td className={styles.table__item}>
                        <span className={styles.table__title}>
                          {item.type_doc}
                        </span>
                      </td>
                      <td className={styles.table__item}>
                        <span className={styles.table__title}>{item.type}</span>
                      </td>
                      <td className={styles.table__item}>
                        <span className={styles.table__title}>{item.status}</span>
                      </td>
                      <td className={styles.table__item}>
                        <span className={styles.table__title}>
                          {item.date_zayavki}
                        </span>
                      </td>
                    </tr>)}

                  </>
                );
              })}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default StatementTable;
